import { getHeadingsFromMarkdown, getLowestHeadingLevel } from "../../navigation/helpers/utils.js";
const DEFAULT_INTRODUCTION_SLUG = "introduction";
const traverseDescription = (description, titlesMap, getHeadingId) => {
  if (!description?.trim()) {
    return [];
  }
  const headings = getHeadingsFromMarkdown(description);
  const lowestLevel = getLowestHeadingLevel(headings);
  const entries = [];
  let currentParent = null;
  if (description && !description.trim().startsWith("#")) {
    const heading = {
      depth: 1,
      value: "Introduction",
      slug: DEFAULT_INTRODUCTION_SLUG
    };
    const id = getHeadingId(heading);
    const title = heading.value;
    entries.push({
      id,
      title,
      type: "text"
    });
    titlesMap.set(id, title);
  }
  for (const heading of headings) {
    if (heading.depth !== lowestLevel && heading.depth !== lowestLevel + 1) {
      continue;
    }
    const entry = {
      id: getHeadingId(heading),
      title: heading.value,
      type: "text"
    };
    titlesMap.set(entry.id, entry.title);
    if (heading.depth === lowestLevel) {
      entry.children = [];
      entries.push(entry);
      currentParent = entry;
    } else if (currentParent) {
      currentParent.children?.push(entry);
    }
  }
  return entries;
};
export {
  DEFAULT_INTRODUCTION_SLUG,
  traverseDescription
};
//# sourceMappingURL=traverse-description.js.map
